/**
 * Role globalne uzytkownika.
 * Odpowiada enumowi `pl.tenify.common.security.GlobalRole`.
 */
export const GLOBAL_ROLES = ['PLAYER', 'TRAINER', 'OWNER', 'ADMIN'] as const;

export type GlobalRole = (typeof GLOBAL_ROLES)[number];

/** Odpowiedz `/api/auth/login` i `/api/auth/refresh` (common-lib: LoginResponse). */
export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  /**
   * Identyfikator sesji. Backend zwraca go TYLKO przy logowaniu —
   * odpowiedz z `/refresh` ma tu `null`, wiec przy odswiezaniu zachowujemy
   * wartosc zapisana podczas logowania.
   */
  sessionId: string | null;
}

/** Sesja przechowywana po stronie przegladarki. */
export interface AuthSession {
  accessToken: string;
  refreshToken: string;
  sessionId: string | null;
  /** `true` — sesja przetrwa zamkniecie przegladarki („Zapamiętaj mnie”). */
  persistent: boolean;
}

/** Uzytkownik odtworzony z zawartosci tokena dostepu. */
export interface AuthUser {
  id: string;
  email: string | undefined;
  roles: GlobalRole[];
}

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

/** Zawezenie napisu do znanej roli globalnej. */
export function isGlobalRole(value: string): value is GlobalRole {
  return (GLOBAL_ROLES as readonly string[]).includes(value);
}
